import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import type { ClientCategoryRow } from './types'

const CATEGORY_COLORS: Record<'A' | 'B' | 'C', string> = {
  A: '#10b981',
  B: '#3b82f6',
  C: '#f59e0b',
}

function formatRub(n: number): string {
  if (Math.abs(n) >= 1_000_000) return `₽ ${(n / 1_000_000).toFixed(1)}M`
  if (Math.abs(n) >= 1_000) return `₽ ${Math.round(n / 1_000)}K`
  return `₽ ${Math.round(n)}`
}

export function ClientCategoriesChart({
  categories,
  onCategoryClick,
}: {
  categories: ClientCategoryRow[]
  onCategoryClick?: (category: 'A' | 'B' | 'C') => void
}) {
  const chartData = categories.map((c) => ({ category: c.category, percent: c.percent }))
  const hasData = categories.some((c) => c.sumRub > 0)

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="text-sm text-gray-500 mb-3">Клиенты по категориям</div>

      <div className="flex-1 min-h-[160px]">
        {hasData ? (
          <ResponsiveContainer width="100%" height="100%" minHeight={120}>
            <BarChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
              <XAxis
                dataKey="category"
                tick={{ fontSize: 12, fill: '#6b7280' }}
                axisLine={{ stroke: '#e5e7eb' }}
                tickLine={false}
              />
              <YAxis
                tick={{ fontSize: 11, fill: '#6b7280' }}
                axisLine={{ stroke: '#e5e7eb' }}
                tickLine={false}
                tickFormatter={(v: number) => `${v}%`}
              />
              <Tooltip
                formatter={(v) => [`${Number(v)}%`, 'Доля']}
                contentStyle={{
                  borderRadius: 8,
                  border: '1px solid #e5e7eb',
                  fontSize: 12,
                }}
              />
              <Bar dataKey="percent" radius={[4, 4, 0, 0]}>
                {chartData.map((d) => (
                  <Cell key={d.category} fill={CATEGORY_COLORS[d.category]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-full flex items-center justify-center text-sm text-gray-400">
            Нет данных за период
          </div>
        )}
      </div>

      <div className="grid grid-cols-3 gap-2 mt-3">
        {categories.map((c) => (
          <button
            key={c.category}
            onClick={() => onCategoryClick?.(c.category)}
            className="text-left rounded-xl border border-gray-100 bg-gray-50 p-2 hover:bg-gray-100 transition-colors"
          >
            <div className="flex items-center gap-1.5 text-xs text-gray-500">
              <span
                className="w-2 h-2 rounded-sm"
                style={{ backgroundColor: CATEGORY_COLORS[c.category] }}
              />
              Кат. {c.category}
            </div>
            <div className="text-sm font-semibold text-gray-900 tabular-nums mt-0.5">
              {formatRub(c.sumRub)}
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}
